/* eslint-disable camelcase */
const first = [
  {
    icon: `material`,
    text: `100% хлопок. Экологичный и приятный на ощупь`
  },
  {
    icon: `quality`,
    text: `Яркие краски. Принт выдерживает 50 стирок`
  },
  {
    icon: `guarantees`,
    text: `Возврат и обмен не выходя из дома`
  }
];

const second = [
  {
    icon: `quality`,
    text: `Качественная профессиональная печать`
  },
  {
    icon: `guarantees`,
    text: `Возврат и обмен не выходя из дома`
  },
  {
    icon: `services`,
    text: `Более 100 тысяч довольных клиентов`
  }
];

const third = [
  {
    icon: `quality`,
    text: `Яркие краски. Принт выдерживает 50 стирок`
  },
  {
    icon: `guarantees`,
    text: `Возврат и обмен не выходя из дома`
  },
  {
    icon: `services`,
    text: `Более 100 тысяч довольных клиентов`
  }
];

export default {
  beanie: first,
  classic_polo_shirt: first,
  classic_tee: first,
  classic_woman_polo: first,
  classic_woman_tee: first,
  full_print_beanie: first,
  full_print_boy_tee: first,
  full_print_girl_tee: first,
  full_print_hoodie: third,
  full_print_kids_sweatshirt: third,
  full_print_man_polo: first,
  full_print_sweatshirt: third,
  full_print_tanktop: first,
  full_print_tee: {
    cotton: first,
    synthetics: third
  },
  full_print_woman_hoodie: third,
  full_print_woman_polo: first,
  full_print_woman_sweatshirt: third,
  full_print_woman_tanktop: first,
  full_print_woman_tee: {
    cotton: first,
    synthetics: third
  },
  hoodie: third,
  kids_tee: first,
  longsleeve: first,
  man_pajama_pants: first,
  man_underpants: first,
  polo_shirt: first,
  sweatshirt: first,
  tanktop: first,
  tee: first,
  woman_pajama_pants: first,
  woman_polo: first,
  woman_tanktop: first,
  woman_tee: first,
  woman_underpants: first,
  default: second
};
